export const ServiceRequestSectionTypesArray = <const>[
  'SubmissionsDetails',
  'RequestForm_Table',
  'Comments',
  'Milestones_Services',
  'ModificationHistory',
  'RequestRows_Table',
];
export type ServiceRequestSectionTypes = typeof ServiceRequestSectionTypesArray[number];
